<template>
  <input
    :id
    type="number"
    v-model.number="inputValue"
    class="form-control"
    :class="{ 'is-invalid': invalid }"
    :disabled
    @blur="$emit('blur')"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

withDefaults(
  defineProps<{
    id: string;
    invalid?: boolean;
    disabled?: boolean;
  }>(),
  { invalid: false, disabled: false }
);

defineEmits<{
  blur: [];
}>();

const model = defineModel<number | null>({ default: null });

// v-model, not :value, so a half-typed "5." isn't rewritten to "5" on the next render.
// `.number` hands back the raw string when it can't parse one, which this stores as `null`.
const inputValue = computed({
  get: () => model.value ?? "",
  set: (value: number | string) => {
    model.value = typeof value === "number" ? value : null;
  },
});
</script>
